import * as z from 'zod'
import { baseEntitySchema } from '../../core/entity.js'
import { storageSchema } from '../../core/interfaces/storage.js'

export const musicXMLSchema = baseEntitySchema.extend({
  type: z.literal('musicxml'),
  url: z.string().url().optional(),
  storage: storageSchema,
  /** GH #3010: the file before the first in-app edit. Null once restored, since a PATCH with undefined never clears */
  originalStorage: storageSchema.describe('The score file before the first in-app edit').nullable().optional(),
})

export type MusicXML = z.infer<typeof musicXMLSchema>

export function isMusicXML(node: unknown): node is MusicXML {
  return musicXMLSchema.safeParse(node).success
}
